<template>
  <div class="tooltip">
    <span>{{ label }}</span>
    <el-tooltip :content="content" :placement="placement">
      <template v-slot:content>
        <slot name="content"></slot>
      </template>
      <i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'tableHeader',
  props: {
    label: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'top'
    }
  }
}
</script>

<style lang="less" scoped>
.tooltip {
  display: flex;
  align-items: center;
  .icon-a-help-circle-obangzhu-xian {
    line-height: 23px;
    font-size: 14px;
    font-weight: 400;
    color: #999;
    margin-left: 2px;
  }
}
</style>
